import { render } from "./imageCarousel.vue?vue&type=template&id=16ec4b14&scoped=true"
import script from "./imageCarousel.vue?vue&type=script&lang=js"
export * from "./imageCarousel.vue?vue&type=script&lang=js"

import "./imageCarousel.vue?vue&type=style&index=0&id=16ec4b14&scoped=true&lang=css"

import exportComponent from "C:\\Users\\krist\\Documents\\pbetoon\\pBetoon-main\\ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ec4b14"]])

export default __exports__